// extracted by mini-css-extract-plugin
export var alignCenter = "_c0-d";
export var bannerShown = "_c0-6";
export var buttonContent = "_c0-0";
export var cardList = "_c0-1";
export var centerContent = "_c0-2";
export var chevron = "_c0-3";
export var closePanelButton = "_c0-k";
export var conversationContextContainer = "_c0-l";
export var conversationDetailContainer = "_c0-4";
export var detailWrapper = "_c0-7";
export var dropdownButton = "_c0-e";
export var dropdownTitle = "_c0-9";
export var fullHeight = "_c0-5";
export var hidden = "_c0-a";
export var icon = "_c0-b";
export var mergeSuggestionWrapper = "_c0-m";
export var panel = "_c0-i";
export var portalButtonsWrapper = "_c0-c";
export var right = "_c0-j";
export var tableSummaryContainer = "_c0-8";
export var tableSummaryHeader = "_c0-g";
export var threeDotsButton = "_c0-f";
export var wide = "_c0-h";